import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { useData } from './hooks'
import { StatBlock } from './StatBlock'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'

export function ActivitySummaryTopStats() {
  const { data } = useData()

  return (
    <Stack direction="row" p={2}>
      <Stack mr="auto">
        <Typography variant="h6">Activity Summary</Typography>

        <Stack direction="row" alignItems="center">
          <AssignmentOutlined color="primary" fontSize="small" />

          <Typography mx={0.5}>Average time to completion:</Typography>

          <Typography fontFamily="Source Sans Pro SemiBold">
            {data?.avgTimeToCompletion ?? <>&mdash;</>} days
          </Typography>
        </Stack>
      </Stack>

      <StatBlock
        label="To Do"
        value={data?.toDoTotalCount}
        percentage={data?.toDoPercentage}
      />
      <StatBlock
        label="In Progress"
        value={data?.inProgressTotalCount}
        percentage={data?.inProgressPercentage}
      />
      <StatBlock
        label="Deferred"
        value={data?.deferredTotalCount}
        percentage={data?.deferredPercentage}
      />
      <StatBlock label="Completed" value={data?.completeTotalCount} />
    </Stack>
  )
}
